import { CloseButton, Grid, GridItem } from '@chakra-ui/react';
import React, { useContext, useMemo } from 'react';
import { commonStyle } from '../../../../common/styles';
import { DialogStateContext } from '../../../../context/DialogStateContextProvider';
import { LanguageContext } from '../../../../context/LanguageContextProvider';
import {
  DialogTrainInfoType,
  DialogTrainsInfoType
} from '../../../../context/TransitsContextProvider';

type Props = {
  placeInfo: DialogTrainsInfoType;
  trainInfo: DialogTrainInfoType;
};

export const Header: React.FC<Props> = (props) => {
  const { placeInfo, trainInfo } = props;
  const { closeDialog } = useContext(DialogStateContext);
  const { language } = useContext(LanguageContext);

  // 言語、電停or電停間、同一区間内の台数に応じて表示する内容を変える
  const message = useMemo(() => {
    // place内にある、選択中の車両と前後の電停が同じ車両の数
    const trainCount = placeInfo.trains.filter(
      (train) =>
        train.station_name_former === trainInfo.station_name_former &&
        train.station_name_latter === trainInfo.station_name_latter
    ).length;
    if (language === 'ja') {
      if (trainInfo.station_name_former === trainInfo.station_name_latter)
        return `${trainInfo.station_name_former}に${trainCount}台の車両が停車中。`;
      else
        return `${trainInfo.station_name_former}、${trainInfo.station_name_latter}の間を${trainCount}台の車両が走行中。`;
    } else if (language === 'en')
      if (trainInfo.station_name_former_en === trainInfo.station_name_latter_en)
        return `There ${
          trainCount >= 2 ? 'are' : 'is'
        } ${trainCount} streetcar${trainCount >= 2 ? 's' : ''} stopped at ${
          trainInfo.station_name_former_en
        }.`;
      else
        return `${trainCount} streetcar${trainCount >= 2 ? 's' : ''} ${
          trainCount >= 2 ? 'are' : 'is'
        } moving between ${trainInfo.station_name_former_en} and ${
          trainInfo.station_name_latter_en
        }.`;
  }, [
    language,
    placeInfo.trains,
    trainInfo.station_name_former,
    trainInfo.station_name_former_en,
    trainInfo.station_name_latter,
    trainInfo.station_name_latter_en
  ]);

  return (
    <Grid
      w='100%'
      h='100%'
      bgColor='#f0f8ff'
      gridTemplateAreas={`'title close'`}
      gridTemplateColumns={`1fr 40px`}
      borderBottom='1px solid black'
    >
      <GridItem
        gridArea='title'
        paddingLeft='5px'
        fontWeight='bold'
        fontSize='11px'
        sx={{
          ...commonStyle.center
        }}
      >
        {message}
      </GridItem>
      <GridItem
        gridArea='close'
        sx={{
          ...commonStyle.center
        }}
      >
        <CloseButton
          color='white'
          bgColor='black'
          w='85%'
          h='85%'
          size='md'
          // chromeの仕様で青い枠線が出てしまうことがあるため対処
          // https://github.com/chakra-ui/chakra-ui/issues/708
          style={{ boxShadow: 'none' }}
          onClick={closeDialog}
        ></CloseButton>
      </GridItem>
    </Grid>
  );
};
